import React, { useRef, useState, useEffect } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

export default function Contactform() {

  const [phone, setPhone] = useState("");
  const [vacancies, setVacancies] = useState([]);
  const [jobTitles, setJobTitles] = useState([]);
  const [locations, setLocations] = useState([]);
  const [selectedJobTitle, setSelectedJobTitle] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);


  // Fetch data for vacancies
  useEffect(() => {
    const fetchVacancies = async () => {
      try {
        const response = await fetch("https://sheetdb.io/api/v1/qb852u808nuvw");
        const data = await response.json();

        if (Array.isArray(data)) {
          setVacancies(data);
          // Extract unique Job Titles and Locations
          const uniqueJobTitles = [...new Set(data.map((item) => item["Job Title"]))];
          const uniqueLocations = [...new Set(data.map((item) => item["Location"]))];
          setJobTitles(uniqueJobTitles);
          setLocations(uniqueLocations);
        }
      } catch (err) {
        console.error("Error fetching vacancies:", err);
      }
    };

    fetchVacancies();
  }, []);


  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    const form = event.target;

    const formData = new FormData();
    formData.append('title', form.formTitle.value);
    formData.append('firstName', form.formFirstName.value);
    formData.append("middleName", form.formMiddleName.value || "");
    formData.append("lastName", form.formLastName.value);
    formData.append("email", form.formEmail.value);
    formData.append("phone", phone);
    formData.append("jobTitle", selectedJobTitle);
    formData.append("skills", form.formSkills.value);
    formData.append("location", selectedLocation);
    formData.append("experienceLevel", form.formExperienceLevel.value);
    formData.append("salaryRange", form.formSalaryRange.value);
    formData.append("expectedToJoin", form.formExpectedToJoin.value);
    formData.append("yearsOfExperience", form.formYearsOfExperience.value);
    formData.append("additionalComments", form.formAdditionalComments.value || "");
    // Append resume and cover letter files
    if (form.formResume.files[0]) {
      formData.append("resume", form.formResume.files[0]);
    }
    if (form.formCoverLetter.files[0]) {
      formData.append("coverLetter", form.formCoverLetter.files[0]);
    }
    try {
      const response = await fetch("https://digisoft.qa/send-cv.php", {
        method: "POST",
        body: formData,
        headers: {
          "Accept": "application/json",
        },
      });
      if (response.ok) {
        setShowSuccessMessage(true);
        console.log('form data:',formData)
        alert("Form submitted successfully!");
        form.reset();
        setPhone("");
        setSelectedJobTitle("");
        setSelectedLocation("");
      } else {
        alert("Failed to submit form. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred while submitting the form.");
      form.reset();
      setPhone("");
      setSelectedJobTitle("");
      setSelectedLocation("");
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <section className="py-5" style={{ backgroundColor: "#f8f9fa" }}>
      <Container>
        <div className="text-center mb-4">
          <p className="text-muted" style={{ padding: "0 10%" }}>
            Submit your CV today through our form and take the first step
            towards exciting career opportunities. Join our talent pool and
            showcase your skills!
          </p>
        </div>
        {showSuccessMessage ? (
          <div className="text-center">
            <p>Thank you for applying. We wish you good luck.</p>
          </div>
        ) : (
          <div className="bg-white rounded shadow form-fill p-4">
            <Form onSubmit={handleSubmit}>
              {/* Title */}
              <Form.Group controlId="formTitle" className="mb-3">
                <Form.Label>Title *</Form.Label>
                <Form.Select required>
                  <option value="">Select Title</option>
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Miss">Miss</option>
                  <option value="Ms">Ms</option>
                  <option value="Professor">Professor</option>
                  <option value="Doctor">Doctor</option>
                  <option value="Councilor">Councilor</option>
                  <option value="Captain">Captain</option>
                  <option value="Sir">Sir</option>
                </Form.Select>
              </Form.Group>

              {/* Full Name */}
              <Row className="g-3">
                <Col md={4}>
                  <Form.Group controlId="formFirstName">
                    <Form.Label>First Name *</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter First Name"
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="formMiddleName">
                    <Form.Label>Middle Name</Form.Label>
                    <Form.Control type="text" placeholder="Enter Middle Name" />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="formLastName">
                    <Form.Label>Last Name *</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Last Name"
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Email and Contact Number */}
              <Row className="g-3 mt-3">
                <Col md={6}>
                  <Form.Group controlId="formEmail">
                    <Form.Label>Email Address *</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="name@example.com"
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="formContactNumber">
                    <Form.Label>Contact Number *</Form.Label>
                    <PhoneInput
                      country={"in"} // Default country
                      value={phone}
                      onChange={(phone) => setPhone(phone)}
                      inputStyle={{
                        width: "100%",
                        borderRadius: "5px",
                        height: "40px",
                      }}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Job Title */}
              <Form.Group controlId="formJobTitle" className="mt-3">
                <Form.Label>Job Title *</Form.Label>
                <Form.Control
                  list="job-title-list"
                  type="text"
                  placeholder="Enter or select a Job Title"
                  value={selectedJobTitle}
                  onChange={(e) => setSelectedJobTitle(e.target.value)}
                  required
                />
                <datalist id="job-title-list">
                  {jobTitles.map((title, index) => (
                    <option key={index} value={title} />
                  ))}
                </datalist>
              </Form.Group>

              {/* Skills */}
              <Form.Group controlId="formSkills" className="mt-3">
                <Form.Label>Skills *</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="e.g., React, Node.js, JavaScript"
                  required
                />
              </Form.Group>

              {/* Job Location */}
              <Form.Group controlId="formJobLocation" className="mt-3">
                <Form.Label>Job Location</Form.Label>
                <Form.Control
                  list="job-location-list"
                  type="text"
                  placeholder="e.g., India, Remote"
                  value={selectedLocation}
                  onChange={(e) => setSelectedLocation(e.target.value)}
                />
                <datalist id="job-location-list">
                  {locations.map((location, index) => (
                    <option key={index} value={location} />
                  ))}
                </datalist>
              </Form.Group>

              {/* Experience Level */}
              <Form.Group controlId="formExperienceLevel" className="mt-3">
                <Form.Label>Experience Level *</Form.Label>
                <Form.Select required>
                  <option value="">Select Experience Level</option>
                  <option value="Entry level">Entry level</option>
                  <option value="Intermediate">Intermediate</option>
                  <option value="Executive level">Executive level</option>
                  <option value="Mid-level">Mid-level</option>
                  <option value="Expert">Expert</option>
                  <option value="Senior level associate">
                    Senior level associate
                  </option>
                  <option value="Middle management">Middle management</option>
                  <option value="Senior Management">Senior Management</option>
                  <option value="C-Level">C-Level</option>
                </Form.Select>
              </Form.Group>

              {/* Salary Range */}
              <Form.Group controlId="formSalaryRange" className="mt-3">
                <Form.Label>Salary Range *</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Salary Range"
                  required
                />
              </Form.Group>

              {/* Expected to Join */}
              <Form.Group controlId="formExpectedToJoin" className="mt-3">
                <Form.Label>Expected to Join *</Form.Label>
                <Form.Select required>
                  <option value="">Select Option</option>
                  <option value="Immediate">Immediate</option>
                  <option value="1 month">1 Month</option>
                  <option value="2-3 months">2-3 Months</option>
                  <option value="Above 3 months">Above 3 Months</option>
                </Form.Select>
              </Form.Group>

              {/* Years of Experience */}
              <Form.Group controlId="formYearsOfExperience" className="mt-3">
                <Form.Label>Years of Experience *</Form.Label>
                <Form.Control
                  type="number"
                  min="0"
                  placeholder="e.g., 2"
                  required
                />
              </Form.Group>

              {/* Upload Resume */}
              <Form.Group controlId="formResume" className="mt-3">
                <Form.Label>Upload Your Resume *</Form.Label>
                <Form.Control type="file" accept=".pdf, .doc, .docx" required />
              </Form.Group>

              {/* Upload Cover Letter */}
              <Form.Group controlId="formCoverLetter" className="mt-3">
                <Form.Label>Upload Your Covering Letter *</Form.Label>
                <Form.Control type="file" accept=".pdf, .doc, .docx" required />
              </Form.Group>

              {/* Additional Comments */}
              <Form.Group controlId="formAdditionalComments" className="mt-3">
                <Form.Label>Additional Comments</Form.Label>
                <Form.Control as="textarea" rows={4} />
              </Form.Group>

              {/* Submit Button */}
              <div className="text-center mt-4 d-flex gap-5 sub-btn">
                <Button type="submit" className="btn form-btns px-5" disabled={isSubmitting}>
                  {isSubmitting ? "Submitting..." : "Submit"}
                </Button>
                <Button type="button" className="btn form-btns px-5" onClick={() => window.location.reload()}>
                  Clear
                </Button>
              </div>
            </Form>
          </div>
        )}
      </Container>
    </section>
  );
}
